import React from 'react';
import {
  Box,
  Container,
  Modal,
  Backdrop,
  Fade,
} from '@mui/material';
import { withStyles } from '@mui/styles';
import PropTypes from 'prop-types';
import _ from 'lodash';
import Page from 'src/components/Page';
import getAcks from 'src/requests/getAcks';
import previewAckApi from 'src/requests/previewAck';
import Results from './Results';
import Toolbar from './Toolbar';

const useStyles = (theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  caseCard: {
    height: '100%'
  },
  modal: {
    position: 'absolute !important',
    display: 'inline-flex',
    height: '100%',
    width: '100%',
    overflow: 'scroll',
    top: '50px !important',
    alignItems: 'flex-start',
    justifyContent: 'center',
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
});

class AckListView extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      cases: [],
      roles: [],
      preview: ''
    };
  }

  componentDidMount = async () => {
    let response = await getAcks();
    const { keycloak } = this.props;
    response = _.map(response, (res, key) => { return { id: key, ...res }; });
    response = _.orderBy(response, ['date_added'], ['desc']);
    this.setState({ cases: response, roles: _.get(keycloak, ['realmAccess', 'roles']) });
  }

  getPreviewAck = async (id) => {
    const preview = await previewAckApi(id);
    this.setState({ preview });
  }

  render() {
    const { classes } = this.props;
    const { cases, roles, preview } = this.state;

    return (
      <Page
        className={classes.root}
        title="Acknowledgements"
      >
        <Container maxWidth={false}>
          <Toolbar roles={roles} />
          <Box mt={3}>
            <Results cases={cases} roles={roles} getPreviewInvoice={this.getPreviewAck} />
          </Box>
          <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            className={classes.modal}
            open={!_.isEmpty(preview)}
            onClose={() => this.setState({ preview: '' })}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
              timeout: 500,
            }}
          >
            <Fade in={!_.isEmpty(preview)}>
              <div className={classes.paper}>
                {/* eslint-disable-next-line */}
                <div dangerouslySetInnerHTML={{ __html: preview }} />
              </div>
            </Fade>
          </Modal>
        </Container>
      </Page>
    );
  }
}

AckListView.propTypes = {
  classes: PropTypes.any,
  keycloak: PropTypes.any,
};

export default withStyles(useStyles)(AckListView);
